import { render, staticRenderFns } from "./UpdateDistricts.vue?vue&type=template&id=558f3782&scoped=true&"
import script from "./UpdateDistricts.vue?vue&type=script&lang=js&"
export * from "./UpdateDistricts.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDistricts.vue?vue&type=style&index=0&id=558f3782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f3782",
  null
  
)

component.options.__file = "UpdateDistricts.vue"
export default component.exports